import { jsx } from 'react/jsx-runtime';
import clsx from 'clsx';

const modalDialogBody = "_modal-dialog-body_cb9hj_1";
const modalDialogBodyInner = "_modal-dialog-body-inner_cb9hj_29";
const styles = {
	modalDialogBody: modalDialogBody,
	modalDialogBodyInner: modalDialogBodyInner
};

const ModalDialogBody = ({ children, className, style, textAlign = "start" }) => {
  return jsx("div", { className: clsx(styles.modalDialogBody, className), "data-text-align": textAlign, "data-zds": true, style, children: jsx("div", { className: styles.modalDialogBodyInner, "data-zds": true, children }) });
};

export { ModalDialogBody };
//# sourceMappingURL=Body.es.js.map
